<template>
  <span class="spinner"></span>
</template>
<script setup lang="ts"></script>

<style scoped lang="postcss">
.spinner {
  --search-loading-border-top: 0.75em solid hsla(var(--color-brand-dark), 0.2);
  --search-loading-border-right: 0.75em solid hsla(var(--color-brand-dark), 0.2);
  --search-loading-border-bottom: 0.75em solid hsla(var(--color-brand-dark), 0.2);
  --search-loading-border-left: 0.75em solid hsl(var(--color-brand-dark));
  --search-loading-max-size: 10em;
  --search-loading-size: 25vw;

  position: relative;
  text-indent: -9999em;
  border-top: var(--search-loading-border-top);
  border-right: var(--search-loading-border-right);
  border-bottom: var(--search-loading-border-bottom);
  border-left: var(--search-loading-border-left);
  transform: translateZ(0);
  animation: spinner 1.1s infinite linear;
  border-radius: 50%;
  width: var(--search-loading-size);
  height: var(--search-loading-size);
  max-width: var(--search-loading-max-size);
  max-height: var(--search-loading-max-size);

  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @media (--lg-viewport) {
    --search-loading-border-top: 1.1em solid hsla(var(--color-brand-dark), 0.2);
    --search-loading-border-right: 1.1em solid hsla(var(--color-brand-dark), 0.2);
    --search-loading-border-bottom: 1.1em solid hsla(var(--color-brand-dark), 0.2);
    --search-loading-border-left: 1.1em solid hsl(var(--color-brand-dark));
  }
}
</style>
